module.exports = "<div id=\"loading-cont\">\n  <div\n    id=\"loading-bar\"\n    [ngStyle]=\"{ width: imagePreloader.loaded + 'vw' }\"\n  ></div>\n</div>\n"